import { c as _c } from "react/compiler-runtime";
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 blender/logotype/binary_tree.glb -o src/3d-models/BinaryTree.tsx -TtD 
Files: blender/logotype/binary_tree.glb [819.42KB] > C:\Users\Max\projects\leetpal\src\3d-models\binary_tree-transformed.glb [84.2KB] (90%)
*/
import { useGLTF } from "@react-three/drei";
import React from "react";
import type * as THREE from "three";
import type { GLTF } from "three-stdlib";
import { assertGltfNodes } from "#/shared/lib/gltfTypeGuard";
type GLTFResult = GLTF & {
  nodes: {
    Circle001: THREE.Mesh;
    Circle001_1: THREE.Mesh;
  };
  materials: {
    ["Main-LR"]: THREE.MeshStandardMaterial;
    Emit: THREE.MeshStandardMaterial;
  };
};
const assetPath = "/assets/binary_tree-transformed.glb";
const REQUIRED_NODES = ["Circle001", "Circle001_1"] as const;
export function BinaryTreeModel(props) {
  const $ = _c(14);
  const gltf = useGLTF(assetPath);
  assertGltfNodes(gltf, REQUIRED_NODES);
  const {
    nodes,
    materials
  } = gltf;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [0, 0, 0];
    t1 = [Math.PI / 2, 0, 0];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const t2 = materials["Main-LR"];
  let t3;
  if ($[2] !== nodes.Circle001.geometry || $[3] !== t2) {
    t3 = <mesh geometry={nodes.Circle001.geometry} material={t2} />;
    $[2] = nodes.Circle001.geometry;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== materials.Emit || $[6] !== nodes.Circle001_1.geometry) {
    t4 = <mesh geometry={nodes.Circle001_1.geometry} material={materials.Emit} />;
    $[5] = materials.Emit;
    $[6] = nodes.Circle001_1.geometry;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <group position={t0} rotation={t1} scale={5.875}>{t3}{t4}</group>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== props || $[12] !== t5) {
    t6 = <group {...props} dispose={null}>{t5}</group>;
    $[11] = props;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
useGLTF.preload(assetPath);